import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { DestroyableComponentBase } from "../../../utils/components/destroyable-component-base";
import { ILine } from "../models/ILine";

@Component({
	selector: "advanced-search",
	templateUrl: "./advanced-search.component.html",
	styleUrls: ["./advanced-search.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class AdvancedSearchComponent extends DestroyableComponentBase {
	//#region PROPERTIES

	@Input() public headers: Array<string>;
	@Input() public lines: Array<ILine>;

	// TODO A ajuster en fonction des lignes (paramétrables).
	public columnSize = 4;

	//#endregion

	//#region METHODS

	constructor() {
		super();
	}

	//#endregion
}
